/* ============================================================
   Product page mode switch.

   Two product-page designs ship on this theme — "sticky" (the V5 Sticky
   Note page) and "afterhours" (the minimal After Hours page) — and the
   visitor picks. The choice is remembered per browser in localStorage.

   This runs synchronously BEFORE either panel is parsed, so it can stamp
   <html data-pn-mode> and the inactive panel never paints (pn-mode.css
   hides it by that attribute). The single 3D deck is carried into the
   active panel's `.pn-deck-mount` on every switch.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'pn-mode', MODES = ['sticky', 'afterhours'], DEFAULT = 'sticky';
  var html = document.documentElement;

  /* Choosing a view is a FULLSCREEN-ONLY thing (Rue, 2026-09-07): "it is only
     in the current fullscreen mode that people can pick their view modes,
     sticky note or afterhours (1 or 2), but for smaller designs we only go
     with smaller versions of afterhours design."

     So below the wide breakpoint the picker is hidden and After Hours is the
     page, whatever the visitor picked. 1100 is the same number
     pn-afterhours.js and pn-sticky.js use to leave their wide canvas, so the
     picker disappears at exactly the moment the fullscreen design does.

     The stored preference is NOT overwritten - it is ignored while the window
     is narrow, so someone who chose Sticky Note goes back to it the moment
     they widen the window again. */
  var WIDE_MIN = 1100;
  function narrow() {
    return (window.innerWidth || document.documentElement.clientWidth || 0) < WIDE_MIN;
  }

  function read() {
    if (narrow()) return 'afterhours';
    try { var v = localStorage.getItem(KEY); return MODES.indexOf(v) > -1 ? v : DEFAULT; }
    catch (e) { return DEFAULT; }
  }

  function apply(mode, persist) {
    html.setAttribute('data-pn-mode', mode);
    if (persist) { try { localStorage.setItem(KEY, mode); } catch (e) {} }

    var panels = document.querySelectorAll('[data-pn-mode-panel]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-pn-mode-panel') !== mode;
    }
    var picks = document.querySelectorAll('[data-pn-mode-pick]');
    for (var j = 0; j < picks.length; j++) {
      picks[j].setAttribute('aria-pressed',
        picks[j].getAttribute('data-pn-mode-pick') === mode ? 'true' : 'false');
    }

    /* one deck and one tracklist, whichever page is showing.
       paranoise-player.js renders the rows into #pn-tracklist-mount BY ID, so
       there can only be one; each panel provides a .pn-tracks-mount slot and
       the rendered node is carried into the active one. */
    var tt = document.querySelector('.pn-tt');
    var mount = document.querySelector('[data-pn-mode-panel="' + mode + '"] .pn-deck-mount');
    if (tt && mount && tt.parentElement !== mount) mount.appendChild(tt);
    var tl = document.getElementById('pn-tracklist-mount');
    var slot = document.querySelector('[data-pn-mode-panel="' + mode + '"] .pn-tracks-mount');
    if (tl && slot && tl.parentElement !== slot) slot.appendChild(tl);

    try { window.dispatchEvent(new CustomEvent('pn:mode', { detail: { mode: mode } })); } catch (e) {}
    if (tt) { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }
  }

  window.PNMode = {
    get: function () { return html.getAttribute('data-pn-mode') || read(); },
    set: function (m) { if (MODES.indexOf(m) > -1) apply(m, true); }
  };

  /* the picker is fixed under the theme header; measure the header so it
     never sits on the header's bottom edge at other zoom levels */
  function placePicker() {
    var hdr = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header');
    var pick = document.querySelector('.pn-mode-pick');
    if (!hdr || !pick) return;
    var b = hdr.getBoundingClientRect().bottom;
    if (b > 0) pick.style.top = Math.round(b + 10) + 'px';
  }
  /* crossing the breakpoint has to re-apply: a window narrowed past 1100px
     must switch to After Hours, and widening again must hand back the
     visitor's own choice */
  var wasNarrow = narrow();
  window.addEventListener('resize', function () {
    var n = narrow();
    if (n !== wasNarrow) { wasNarrow = n; apply(read(), false); }
  });
  window.addEventListener('resize', placePicker);
  document.addEventListener('DOMContentLoaded', placePicker);
  setTimeout(placePicker, 300);

  apply(read(), false);                                   /* stamp <html> now */
  document.addEventListener('DOMContentLoaded', function () { apply(read(), false); });

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-pn-mode-pick]');
    if (!b) return;
    e.preventDefault();
    window.PNMode.set(b.getAttribute('data-pn-mode-pick'));
  });
})();
